export const theme = {
  colors: {
    white: "#FFFFFF",
    border: "#444444",
    background: "#005000",
  },
  sizes: {
    handleWidth: "10px",
    handleHeight: "34px",
    buttonSize: "15px",
    buttonIconSize: "10px",
  },
  spacing: {
    small: "2px",
    medium: "8px",
    large: "16px",
  },
  borderRadius: {
    small: "3px",
    medium: "8px",
    circle: "50%",
  },
  zIndex: {
    handle: 100,
    button: 101,
  },
} as const;
